import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { APISD } from "../../../../../../../config/apisd";
import { APIMS } from "../../../../../../../config/apims";
import { useMediaQuery } from "react-responsive";
import "bulma/css/bulma.css";
import "../../../../../../../index.css";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserGraduate,
  faMagnifyingGlass,
  faPlus,
  faTrash,
  faPenToSquare
} from "@fortawesome/free-solid-svg-icons";
import { PulseLoader } from "react-spinners";
import ModalAdd from "./modal/add";
import ModalUpdate from "./modal/update";
import ToastSuccess from "../../../../../../NotificationToast/ToastSuccess";


export default function KategoriKomentar() {
  document.title = "Kategori Komentar";

  const page = 1;
  const limit = 1000;
  const ascending = 1;
  const descending = 0;
  const keyword = "";

  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });

  const [previewStudent, setPreviewStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingSchool, setLoadingSchool] = useState(false);

  const firstLoadDone = useRef(false);
  const filterRevision = useRef(0);
  const fetchingRef = useRef(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");

  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);

  const [getDataLevel, setGetDataLevel] = useState([]);
  const [getDataKelas, setGetDataKelas] = useState([]);

  const [loadingLevel, setLoadingLevel] = useState(false);
  const [loadingKelas, setLoadingKelas] = useState(false);

  const [searchKeyword, setSearchKeyword] = useState("");
  const [getData, setGetData] = useState([]);
  const [selectedStudentKeys, setSelectedStudentKeys] = useState([]);
  const semesterDataCache = useRef({});

  const [hasSearched, setHasSearched] = useState(false);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const [selectedAcademicYearId, setSelectedAcademicYearId] = useState("");

  const [modalCetak, setModalCetak] = useState(false);

  const [id, setId] = useState();
  const [nameUpdate, setNameUpdate] = useState("");
  const [rowUpdate, setRowUpdate] = useState(null);

  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);

  const [formFilter, setFormFilter] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id: "",
    ysb_kelas_id: "",
  });

  const location = useLocation();
  const [, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });

  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems =
      JSON.parse(localStorage.getItem("role_permission")) || [];

    if (level === "developer" || level === "superadmin") {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1,
      });
      return;
    }

    const foundPermission = storageItems.find(
      (item) => item.menu?.url === location.pathname
    );

    if (!foundPermission) {
      navigate("/dashboard");
    } else {
      setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
      });
    }
  }, [location.pathname, navigate, setPermission]);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const collator = useMemo(
    () =>
      new Intl.Collator("id", {
        numeric: true,
        sensitivity: "base",
      }),
    []
  );

  const safeStr = (value) =>
    value === null || value === undefined ? "" : String(value);

  // Urutan jenjang sekolah: SD, SMP, lalu SMA (termasuk SDIA/SMPIA/SMAIA).
  const schoolOrder = (school) => {
    const label = String(school?.school_name || school?.school_code || "").toUpperCase().trim();
    if (/(^|[^A-Z])SD/.test(label)) return 0;
    if (/(^|[^A-Z])SMP/.test(label)) return 1;
    if (/(^|[^A-Z])SMA/.test(label)) return 2;
    return 3;
  };

  // Filter dependencies: Cabang -> Sekolah -> Tingkatan -> Kelas.
  useEffect(() => {
    let cancelled = false;
    const loadOptions = async () => {
      setLoading(true);
      try {
        const [branchRes, semesterRes, yearRes] = await Promise.all([
          APIMS.get(`/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`, fetchParams),

          APIMS.get(`/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`, fetchParams),

          APIMS.get(`/api/academic-years?page=${page}&limit=${limit}&ascending=${descending}`, fetchParams),
        ]);
        if (cancelled) return;
        const branches = branchRes?.data?.data || [];
        const semesters = semesterRes?.data?.data || [];
        const years = yearRes?.data?.data || [];
        const active = semesters.find((item) => Number(item.status) === 1) || semesters[0];
        const year = years.find((item) =>
          String(item.id) === String(active?.ysb_academic_year_id) ||
          (active?.name_year && String(item.name_year) === String(active.name_year))
        );
        setGetDataBranch(branches);
        setGetDataSemesterMap(semesters);
        setAcademicYears(years);
        setSelectedAcademicYearId(String(year?.id || active?.ysb_academic_year_id || ""));
        setFormFilter((old) => ({ ...old,
          ysb_branch_id: branches[0]?.branch_code || "",
          ysb_semester_id: active?.id || "",
        }));
      } catch (error) {
        if (!cancelled) swal({ title: "Gagal", text: error?.response?.data?.message || "Gagal memuat filter rombel", icon: "error" });
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    loadOptions();
    return () => { cancelled = true; };
  }, [ascending, descending, fetchParams, keyword, limit, page, storageBranchGroping, storageLevel]);

  useEffect(() => {
    let cancelled = false;
    const branchId = formFilter.ysb_branch_id;
    if (!branchId) return;
    const loadSchools = async () => {
      setLoadingSchool(true);
      try {
        const response = await APIMS.get(`/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`, fetchParams);

        if (cancelled) return;
        
        let schools = response?.data?.data || [];
        if (["developer", "superadmin"].includes(storageLevel))
          schools = schools.filter((item) => String(item.ysb_branch_id) === String(branchId));
        if (branchId === "BKS") schools = schools.filter((item) => item.school_code !== "BASEMENT_BEKASI");
        schools = [...schools].sort((a, b) => schoolOrder(a) - schoolOrder(b) || collator.compare(a.school_name || "", b.school_name || ""));
        setGetDataSchool(schools);
        setFormFilter((old) => ({ ...old, ysb_school_id: schools[0]?.school_code || "", ysb_grade_level_id: "", ysb_kelas_id: "" }));
      } catch (error) {
        if (!cancelled) {
          setGetDataSchool([]);
          setFormFilter((old) => ({ ...old, ysb_school_id: "", ysb_grade_level_id: "", ysb_kelas_id: "" }));
          swal({ title: "Gagal", text: error?.response?.data?.message || "Gagal memuat sekolah", icon: "error" });
        }
      } finally { if (!cancelled) setLoadingSchool(false); }
    };
    loadSchools();
    return () => { cancelled = true; };
  }, [formFilter.ysb_branch_id, ascending, collator, fetchParams, limit, page, storageLevel]);

  useEffect(() => {
    let cancelled = false;
    const schoolId = formFilter.ysb_school_id;
    const branchId = formFilter.ysb_branch_id;
    if (!schoolId) { setLoadingLevel(false); return; }
    const loadLevels = async () => {
      setLoadingLevel(true);
      try {
        const response = await APIMS.get(`/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`, fetchParams);
        if (cancelled) return;
        const school = getDataSchool.find((item) => String(item.school_code) === String(schoolId));
        const levels = (response?.data?.data || [])
          .filter((item) =>
            (String(item.ysb_school_id) === String(schoolId) ||
              (school?.id != null && String(item.ysb_school_id) === String(school.id))) &&
            String(item.ysb_branch_id) === String(branchId)
          )
          .sort((a, b) => collator.compare(a.name_level || "", b.name_level || ""));
        setGetDataLevel(levels);
        setFormFilter((old) => ({ ...old, ysb_grade_level_id: levels[0]?.id || "", ysb_kelas_id: "" }));
      } catch (error) {
        if (!cancelled) {
          setGetDataLevel([]);
          setFormFilter((old) => ({ ...old, ysb_grade_level_id: "", ysb_kelas_id: "" }));
          swal({ title: "Gagal", text: error?.response?.data?.message || "Gagal memuat tingkatan", icon: "error" });
        }
      } finally { if (!cancelled) setLoadingLevel(false); }
    };
    loadLevels();
    return () => { cancelled = true; };
  }, [formFilter.ysb_school_id, formFilter.ysb_branch_id, getDataSchool, ascending, collator, fetchParams, limit, page, storageLevel]);

  useEffect(() => {
    let cancelled = false;
    const gradeId = formFilter.ysb_grade_level_id;
    const schoolId = formFilter.ysb_school_id;
    const branchId = formFilter.ysb_branch_id;
    if (!gradeId) { setLoadingKelas(false); return; }
    const loadClasses = async () => {
      setLoadingKelas(true);
      try {
        const response = await APIMS.get(`/api/kelas?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`, fetchParams);
        if (cancelled) return;
        const school = getDataSchool.find((item) => String(item.school_code) === String(schoolId));
        const classes = (response?.data?.data || []).filter((item) =>
          String(item.ysb_grade_level_id) === String(gradeId) &&
          (String(item.ysb_school_id) === String(schoolId) ||
            (school?.id != null && String(item.ysb_school_id) === String(school.id))) &&
          String(item.ysb_branch_id) === String(branchId) &&
          (item.ysb_academic_year_id == null || item.ysb_academic_year_id === "" ||
            String(item.ysb_academic_year_id) === String(selectedAcademicYearId))
        ).sort((a, b) => collator.compare(a.name_kelas || "", b.name_kelas || ""));
        setGetDataKelas(classes);
        setFormFilter((old) => ({ ...old, ysb_kelas_id: classes[0]?.id || "" }));
      } catch (error) {
        if (!cancelled) {
          setGetDataKelas([]);
          setFormFilter((old) => ({ ...old, ysb_kelas_id: "" }));
          swal({ title: "Gagal", text: error?.response?.data?.message || "Gagal memuat kelas", icon: "error" });
        }
      } finally { if (!cancelled) setLoadingKelas(false); }
    };
    loadClasses();
    return () => { cancelled = true; };
  }, [formFilter.ysb_grade_level_id, formFilter.ysb_school_id, formFilter.ysb_branch_id, selectedAcademicYearId, getDataSchool, ascending, collator, fetchParams, limit, page, storageLevel]);

  const activeSemester = getDataSemesterMap.find((item) => Number(item.status) === 1);
  const activeAcademicYear = academicYears.find((year) =>
    String(year.id) === String(activeSemester?.ysb_academic_year_id) ||
    (activeSemester?.name_year && String(year.name_year) === String(activeSemester.name_year))
  );
  const semesterOptions = useMemo(() => {
    const year = academicYears.find((item) => String(item.id) === String(selectedAcademicYearId));
    return getDataSemesterMap.filter((item) =>
      String(item.ysb_academic_year_id) === String(selectedAcademicYearId) ||
      (year && String(item.name_year) === String(year.name_year))
    ).sort((a, b) => Number(a.semester) - Number(b.semester));
  }, [academicYears, getDataSemesterMap, selectedAcademicYearId]);
  const selectedSemester = semesterOptions.find((item) => String(item.id) === String(formFilter.ysb_semester_id));
  const filtersLoading = loading || loadingSchool || loadingLevel || loadingKelas;
  const complete = !!selectedAcademicYearId && !!selectedSemester &&
    !!formFilter.ysb_branch_id && !!formFilter.ysb_school_id &&
    !!formFilter.ysb_grade_level_id && !!formFilter.ysb_kelas_id && !filtersLoading;

  const GetResponseData = useCallback(async () => {
    if (!complete || fetchingRef.current) return false;
    const revision = filterRevision.current;
    fetchingRef.current = true;
    setIsFetching(true);
    setSelectedStudentKeys([]);
    try {
      // Semua semester dimuat sekaligus agar pindah tab tidak perlu POST ulang.
      const results = await Promise.all(semesterOptions.map(async (semester) => {
        // const response = await APISD.post("/api/comment-categories", {
        //   ysb_academic_year_id: selectedAcademicYearId,
        //   ysb_semester_id: semester.id,
        //   ysb_branch_id: formFilter.ysb_branch_id,
        //   ysb_school_id: formFilter.ysb_school_id,
        //   ysb_grade_level_id: formFilter.ysb_grade_level_id,
        //   ysb_kelas_id: formFilter.ysb_kelas_id,
        // }, fetchParams);

        const response = await APISD.get("/api/comment-categories", {
            ...fetchParams,
            params: {
                ysb_academic_year_id: selectedAcademicYearId,
                ysb_semester_id: semester.id,
                ysb_branch_id: formFilter.ysb_branch_id,
                ysb_school_id: formFilter.ysb_school_id,
                ysb_grade_level_id: formFilter.ysb_grade_level_id,
                ysb_kelas_id: formFilter.ysb_kelas_id,
                page: 1,
                limit: 1000,
                ascending,
                search: "",
                branch: localStorage.getItem("branch") || "",
                level: localStorage.getItem("level") || "",
            },
        });
                const result = response?.data?.data;
        const rows = Array.isArray(result) ? result : [];
        const filteredRows = rows.filter((item) =>
          String(item.ysb_academic_year_id) === String(selectedAcademicYearId) &&
          String(item.ysb_semester_id) === String(semester.id) &&
          String(item.ysb_branch_id) === String(formFilter.ysb_branch_id) &&
          String(item.ysb_school_id) === String(formFilter.ysb_school_id) &&
          String(item.ysb_grade_level_id) === String(formFilter.ysb_grade_level_id) &&
          String(item.ysb_kelas_id) === String(formFilter.ysb_kelas_id)
        );
        return [String(semester.id), filteredRows];
      }));
      if (revision !== filterRevision.current) return false;
      semesterDataCache.current = Object.fromEntries(results);
      setGetData(semesterDataCache.current[String(formFilter.ysb_semester_id)] || []);
      setHasSearched(true);
      setIsFilterDirty(false);
      return true;
    } catch (error) {
      if (revision !== filterRevision.current) return false;
      semesterDataCache.current = {};
      setGetData([]);
      setHasSearched(false);
      setIsFilterDirty(true);
      swal({ title: "Gagal", text: error?.response?.data?.message || "Gagal mengambil data rapor", icon: "error" });
      return false;
    } finally {
      fetchingRef.current = false;
      setIsFetching(false);
    }
  }, [complete, semesterOptions, selectedAcademicYearId, formFilter.ysb_semester_id, formFilter.ysb_grade_level_id, formFilter.ysb_school_id, formFilter.ysb_branch_id, formFilter.ysb_kelas_id, fetchParams]);

  useEffect(() => {
    if (complete && !firstLoadDone.current && !isFilterDirty) {
      firstLoadDone.current = true;
      GetResponseData();
    }
  }, [complete, isFilterDirty, GetResponseData]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setSelectedStudentKeys([]);
    filterRevision.current += 1;
    semesterDataCache.current = {};
    if (name === "ysb_academic_year_id") {
      const year = academicYears.find((item) => String(item.id) === String(value));
      const options = getDataSemesterMap.filter((item) =>
        String(item.ysb_academic_year_id) === String(value) ||
        (year && String(item.name_year) === String(year.name_year))
      ).sort((a, b) => Number(a.semester) - Number(b.semester));
      const selected = options.find((item) => Number(item.status) === 1) || options[0];
      setSelectedAcademicYearId(value);
      setFormFilter((old) => ({ ...old, ysb_semester_id: selected?.id || "" }));
    } else {
      const reset = name === "ysb_branch_id"
        ? { ysb_school_id: "", ysb_grade_level_id: "", ysb_kelas_id: "" }
        : name === "ysb_school_id"
        ? { ysb_grade_level_id: "", ysb_kelas_id: "" }
        : name === "ysb_grade_level_id" ? { ysb_kelas_id: "" } : {};
      if (name === "ysb_branch_id") setGetDataSchool([]);
      if (["ysb_branch_id", "ysb_school_id"].includes(name)) setGetDataLevel([]);
      if (["ysb_branch_id", "ysb_school_id", "ysb_grade_level_id"].includes(name)) setGetDataKelas([]);
      setFormFilter((old) => ({ ...old, [name]: value, ...reset }));
    }
    setIsFilterDirty(true);
    setHasSearched(false);
    setGetData([]);
    setSearchKeyword("");
  };

  const handleCari = () => {
    if (!complete || isFetching) return;
    setSearchKeyword("");
    setSelectedStudentKeys([]);
    GetResponseData();
  };

  const switchSemester = (semester) => {
    if (!semester?.id || isFetching || String(formFilter.ysb_semester_id) === String(semester.id)) return;
    const cached = semesterDataCache.current[String(semester.id)];
    setFormFilter((old) => ({ ...old, ysb_semester_id: semester.id }));
    setGetData(cached || []);
    setSelectedStudentKeys([]);
    setSearchKeyword("");
  };

    const deleteById = async (id, name) => {
    Swal.fire({
      title: "Hapus data ini?",
      html: `<p class="sims-delete-description">Data <strong></strong> yang dihapus tidak dapat dikembalikan.</p>`,
      icon: "warning",
      customClass: {
        popup: "sims-delete-popup",
        icon: "sims-delete-icon",
        title: "sims-delete-title",
        actions: "sims-delete-actions",
        confirmButton: "sims-delete-confirm",
        cancelButton: "sims-delete-cancel",
        validationMessage: "sims-delete-validation",
      },
      buttonsStyling: false,
      showCancelButton: true,
      confirmButtonText: "Hapus data",
      cancelButtonText: "Batal",
      reverseButtons: true,
      focusCancel: true,

      didOpen: (popup) => {
        popup.querySelector(".sims-delete-description strong").textContent = name || "Kategori Komentar";
      },
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        try {
          const response = await APISD.delete(
            `/api/comment-categories/${id}`,
            fetchParams
          );
  
          if (response.data.error) {
            throw new Error(response.data.message);
          }
  
          return response;
        } catch (error) {
          Swal.showValidationMessage(
            error.response?.data?.message || "Gagal menghapus data"
          );
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        ToastSuccess.fire({
          icon: "success",
          title: "Data berhasil dihapus",
        });
        GetResponseData();
      }
    });
  };

  const filteredData = useMemo(() => {
    let rows = Array.isArray(getData) ? [...getData] : [];

    const searchValue = safeStr(searchKeyword)
      .trim()
      .toLowerCase();

    if (searchValue) {
      rows = rows.filter((student) => {
        const studentName = safeStr(
          student?.nama_siswa || student?.name_student
        ).toLowerCase();


        return (
          studentName.includes(searchValue)
        );
      });
    }

    rows.sort((a, b) => collator.compare(
      safeStr(a?.name_student || a?.nama_siswa),
      safeStr(b?.name_student || b?.nama_siswa)
    ));

    return rows;
  }, [collator, getData, searchKeyword]);

  const viewModalUpdate = (row) => {
    setId(row?.id);
    setNameUpdate(row?.name_categories || "");
    setRowUpdate(row);
    setModalUpdate(true);
  };

  const toTitleCase = (value) => {
    const text = safeStr(value).toLowerCase().trim();

    if (!text) {
      return "";
    }

    return text.replace(/\w\S*/g, (word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
  };

  return (
    <>
      <style>{`
        .rapor-header-actions {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 12px;
          margin-left: auto;
          flex-wrap: wrap;
        }
        .rapor-header-actions .sims-table-tab-semester-switch {
          flex-shrink: 0;
        }
        .rapor-bulk-action {
          border: 1px solid #dfb900;
          border-radius: 7px;
          background: #FFD600;
          color: #302800;
          font-size: 13px;
          font-weight: 700;
          padding: 8px 12px;
          cursor: pointer;
          white-space: nowrap;
        }
        .rapor-bulk-action:hover { background: #f3cb00; }
        .rapor-checkbox { width: 16px; height: 16px; cursor: pointer; vertical-align: middle; }
        .rapor-print-button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 7px;
          flex-shrink: 0;
          white-space: nowrap;
          border: 1px solid var(--rapor-border) !important;
          background: var(--rapor-bg) !important;
          color: var(--rapor-text) !important;
          border-radius: 7px;
          padding: 8px 11px;
          font-size: 13px;
          font-weight: 600;
          line-height: 1.3;
          cursor: pointer;
          box-shadow: 0 2px 5px rgba(20, 37, 76, 0.07);
          transition: background-color .18s ease, box-shadow .18s ease, transform .18s ease;
        }
        .rapor-print-button:hover {
          background: var(--rapor-hover) !important;
          box-shadow: 0 4px 10px rgba(20, 37, 76, 0.13);
          transform: translateY(-2px);
        }
        .rapor-print-button:active {
          transform: translateY(0);
          box-shadow: 0 1px 3px rgba(20, 37, 76, 0.1);
        }
        .rapor-print-button:focus-visible {
          outline: 2px solid var(--rapor-text);
          outline-offset: 2px;
        }
      `}</style>

      {/* {modalCetak && (
        <ModalCetak
          GetResponseData={GetResponseData}
          show={modalCetak}
          onHide={() => setModalCetak(false)}
        />
      )}

      {previewStudent && (
        <PreviewFoto
          student={previewStudent}
          show={true}
          onHide={() => setPreviewStudent(null)}
        />
      )} */}

      {modalAdd && (
        <ModalAdd
          GetResponseData={GetResponseData}
          show={modalAdd}
          onHide={() => setModalAdd(false)}
          filterValues={{ ...formFilter, ysb_academic_year_id: selectedAcademicYearId }}
          semesterOptions={semesterOptions}
          branches={getDataBranch}
        />
      )}

      {modalUpdate && (
        <ModalUpdate
          GetResponseData={GetResponseData}
          nameUpdate={nameUpdate}
          row={rowUpdate}
          id={id}
          show={modalUpdate}
          onHide={() => setModalUpdate(false)}
          filterValues={{ ...formFilter, ysb_academic_year_id: selectedAcademicYearId }}
          semesterOptions={semesterOptions}
          branches={getDataBranch}
        />
      )}
      <div className="body sims-page">
        <div className="page-header-card">
            <div className="page-header-top d-flex">
                <div className="page-title-wrap">
                    <span className="page-title-icon">
                        <FontAwesomeIcon icon={faUserGraduate} />
                    </span>

                    <h4 className="page-title-text">
                        Kategori Komentar
                    </h4>
                </div>

                <div className="ml-auto">
                    <button
                        onClick={() => setModalAdd(true)}
                        className="btn btn-create sims-header-button"
                    >
                    <FontAwesomeIcon icon={faPlus} />
                        <span>{isTabletOrMobile ? "Kategori Komentar" : "Tambah Kategori Komentar"}</span>
                    </button>
                </div>

            </div>

            <nav
                aria-label="breadcrumb"
                className="sims-breadcrumb-nav mt-4"
            >
            <ol className="sims-breadcrumb">
                <li className="sims-breadcrumb-item">
                    <Link to="/rapor-siakad">Rapor</Link>
                </li>

                <li className="sims-breadcrumb-separator">/</li>

                <li
                    className="sims-breadcrumb-item active"
                    aria-current="page"
                >
                    Kategori Komentar
                </li>
            </ol>
            </nav>
        </div>

        <div className="body-content sims-content">
          {loading ? (
            <div className="sims-filter-card">
              {Array.from({ length: 6 }).map((_, index) => (
                <div
                  key={`filter-skeleton-${index}`}
                  className="shimmer sims-filter-skeleton"
                />
              ))}
            </div>
          ) : (
            <div className="sims-filter-card">
              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Tahun Ajaran
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_academic_year_id"
                  value={selectedAcademicYearId}
                  onChange={handleChange}
                >
                  <option value="" disabled>Pilih Tahun Ajaran</option>
                  {academicYears.map((year) => (
                    <option key={year.id} value={year.id}>
                      {year.name_year}{activeAcademicYear && String(year.id) === String(activeAcademicYear.id) ? " • Aktif" : ""}
                    </option>
                  ))}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Cabang
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_branch_id"
                  value={formFilter.ysb_branch_id}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Pilih Cabang
                  </option>

                  {getDataBranch.map((branch, index) => (
                    <option
                      key={branch?.branch_code || index}
                      value={branch?.branch_code}
                    >
                      {branch?.branch_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Sekolah
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_school_id"
                  value={formFilter.ysb_school_id}
                  onChange={handleChange}
                  disabled={
                    loadingSchool ||
                    !formFilter.ysb_branch_id
                  }
                >
                  <option value="" disabled>
                    {!formFilter.ysb_branch_id
                      ? "Pilih Cabang terlebih dahulu"
                      : loadingSchool
                      ? "Memuat data sekolah..."
                      : "Pilih Sekolah"}
                  </option>

                  {!loadingSchool &&
                    getDataSchool.map((school, index) => (
                      <option
                        key={school?.school_code || index}
                        value={school?.school_code}
                      >
                        {school?.school_name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Tingkatan
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_grade_level_id"
                  value={formFilter.ysb_grade_level_id}
                  onChange={handleChange}
                  disabled={
                    loadingLevel ||
                    !formFilter.ysb_school_id
                  }
                >
                  <option value="" disabled>
                    {!formFilter.ysb_school_id
                      ? "Pilih Sekolah terlebih dahulu"
                      : loadingLevel
                      ? "Memuat data tingkatan..."
                      : "Pilih Tingkatan"}
                  </option>

                  {!loadingLevel &&
                    getDataLevel.map((level, index) => (
                      <option
                        key={level?.id || index}
                        value={level?.id}
                      >
                        {level?.name_level}
                      </option>
                    ))}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Kelas
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_kelas_id"
                  value={formFilter.ysb_kelas_id}
                  onChange={handleChange}
                  disabled={
                    loadingKelas ||
                    !formFilter.ysb_grade_level_id
                  }
                >
                  <option value="" disabled>
                    {!formFilter.ysb_grade_level_id
                      ? "Pilih Tingkatan terlebih dahulu"
                      : loadingKelas
                      ? "Memuat data kelas..."
                      : "Pilih Kelas"}
                  </option>

                  {!loadingKelas &&
                    getDataKelas.map((kelas, index) => (
                      <option
                        key={kelas?.id || index}
                        value={kelas?.id}
                      >
                        {kelas?.name_kelas}
                      </option>
                    ))}
                </select>
              </div>

              <div className="sims-filter-action">
                <button
                  type="button"
                  onClick={handleCari}
                  disabled={!complete || !isFilterDirty || isFetching}
                  className="sims-filter-button"
                >
                  Tampilkan Data
                </button>
              </div>

              
            </div>
          )}

          {isFetching && (
            <div className="sims-loading">
              <PulseLoader color="#3f5bea" size={12}/>
            </div>
          )}

          {!filtersLoading && !isFetching && !hasSearched && isFilterDirty && (
            <div className="sims-empty-state">
              {complete ? "Silakan klik Tampilkan Data" : "Silakan lengkapi filter terlebih dahulu"}
            </div>
          )}

          {hasSearched && !isFilterDirty && !isFetching && (
            <>
              <div className="sims-table-tab-card ">

                <div className="sims-table-tab-head">
                  <div className="sims-table-tab-title">
                    <h5>{getDataLevel.find((item) => String(item.id) === String(formFilter.ysb_grade_level_id))?.name_level || "Tingkatan"} {getDataKelas.find((item) => String(item.id) === String(formFilter.ysb_kelas_id))?.name_kelas || "Kelas"} - Semester {selectedSemester?.semester || "-"}</h5>
                  </div>
                  <div className="rapor-header-actions">
                    <div className="sims-table-tab-semester-switch">
                    {semesterOptions.map((semester) => (
                      <button
                        type="button"
                        key={semester.id}
                        className={`sims-table-tab-semester ${String(formFilter.ysb_semester_id) === String(semester.id) ? "is-active" : ""}`}
                        onClick={() => switchSemester(semester)}
                        disabled={isFetching}
                      >
                        Semester {semester.semester}
                      </button>
                    ))}
                    </div>
                  </div>
                </div>


                <div className="sims-search-wrap mb-3 mt-3 px-2">
                  <FontAwesomeIcon
                    icon={faMagnifyingGlass}
                    className="sims-search-icon"
                  />

                  <input
                    type="text"
                    className="sims-search-input"
                    placeholder="Cari nama siswa..."
                    value={searchKeyword}
                    onChange={(event) =>
                      setSearchKeyword(event.target.value)
                    }
                  />
                </div>

                <div className="sims-table-tab-wrap ">
                  <div className="sims-table-tab sims-table-scroll">
                     <table className="sims-table" style={{ minWidth: "900px" }}>
                       <thead>
                        <tr>
                            <th className="sims-col-number">No</th>
                            <th>Komentar</th>
                            <th className="sims-col-action">Aksi</th>
                        </tr>
                       </thead>
                       <tbody>
                         {filteredData.length === 0 ? (
                           <tr>
                             <td colSpan={3} className="sims-empty-state">
                               <div className="sims-empty-state-content">Data kategori rapor tidak ditemukan</div>
                             </td>
                           </tr>
                         ) : filteredData.map((row, index)  => (
                           <tr key={row?.id || index}>
                             <td className="sims-col-number">
                               <span className="sims-number-badge">{index + 1}</span>
                             </td>
                             <td>
                                <span className="sims-text-bold">
                                {row.name_categories}
                                </span>
                            </td>
                            <td className="sims-col-action">
                                <div className="sims-action-wrap">
                                    <button
                                        type="button"
                                        className="sims-action-button sims-action-edit"
                                        title="Edit tipe leger"
                                        onClick={() =>
                                        viewModalUpdate(row)
                                        }
                                    >
                                        <FontAwesomeIcon icon={faPenToSquare} />
                                    </button>

                                    <button
                                        type="button"
                                        className="sims-action-button sims-action-delete"
                                        title="Hapus tipe leger"
                                        onClick={() => deleteById(row?.id, row?.name_categories)}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </div>
                            </td>
                           </tr>
                         ))}
                       </tbody>
                     </table>
                   </div>
                 </div>

              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
